import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,

  otpLoading: false,
  otpSuccess: false,
  otpVerified: false,
  verifyOrderLoading: false,

    transactions: [],
  transactionsLoading: false,
  transactionsError: null,
};

const offlineOrderSlice = createSlice({
  name: "offline_order",
  initialState,
  reducers: {
    //  RESET ACTION
    resetOfflineOrderState: () => initialState,

    // ───── Order Creation ─────
    createOfflineOrderRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createOfflineOrderSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    createOfflineOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ───── OTP ─────
    generateOtpRequest: (state) => {
      state.otpLoading = true;
      state.otpSuccess = false;
      state.error = null;
    },
    generateOtpSuccess: (state) => {
      state.otpLoading = false;
      state.otpSuccess = true;
    },
    generateOtpFailure: (state, action) => {
      state.otpLoading = false;
      state.otpSuccess = false;
      state.error = action.payload;
    },

    verifyOtpRequest: (state) => {
      state.otpLoading = true;
      state.error = null;
    },
    verifyOtpSuccess: (state) => {
      state.otpLoading = false;
      state.otpVerified = true;
    },
    verifyOtpFailure: (state, action) => {
      state.otpLoading = false;
      state.otpVerified = false;
      state.error = action.payload;
    },

    // ───── Order Verification ─────
    verifyOrderRequest: (state) => {
      state.verifyOrderLoading = true;
      state.error = null;
    },
    verifyOrderSuccess: (state) => {
      state.verifyOrderLoading = false;
    },
    verifyOrderFailure: (state, action) => {
      state.verifyOrderLoading = false;
      state.error = action.payload;
    },

    // ───── GetCustomerOfflineTransactions ─────
    getCustomerOfflineTransactionsRequest: (state) => {
      state.transactionsLoading = true;
      state.transactionsError = null;
    },
    getCustomerOfflineTransactionsSuccess: (state, action) => {
      state.transactionsLoading = false;
      state.transactions = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
    },
    getCustomerOfflineTransactionsFailure: (state, action) => {
      state.transactionsLoading = false;
      state.transactionsError = action.payload;
    },
  },
});

export const {
  resetOfflineOrderState,
  createOfflineOrderRequest,
  createOfflineOrderSuccess,
  createOfflineOrderFailure,
  generateOtpRequest,
  generateOtpSuccess,
  generateOtpFailure,
  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpFailure,
  verifyOrderRequest,
  verifyOrderSuccess,
  verifyOrderFailure,
  getCustomerOfflineTransactionsRequest,
  getCustomerOfflineTransactionsSuccess,
  getCustomerOfflineTransactionsFailure,
} = offlineOrderSlice.actions;

export default offlineOrderSlice.reducer;
